import { createContext, useContext, useEffect, useState } from "react";
import { useFilterContext } from "../../../hooks/FilterContext";
import { useLazySearchFeeGroupsQuery } from "../../../services/headofficeadmin";

const SearchFeesContext = createContext();

export const useSearchFees = () => useContext(SearchFeesContext);


const SearchFeesProvider = ({ children, searchType}) => {

    const { filter, isReady } = useFilterContext();
    
    const [cacheKey, setCacheKey] = useState(new Date().valueOf());

    
    const [sort, setSort] = useState("feeDate+ASC");
    const [limit, setLimit] = useState(25);
    
    const [searchTrigger, { data, isLoading, isFetching, isError, error, isUninitialized }] = useLazySearchFeeGroupsQuery();

    //console.log("Data", data);

    const { hasMore, results, pagination } = data || { results: [], pagination: {page: 0}, hasMore: true };
    const { page } = pagination || { page: 0 };

    const isNextPageLoading = isFetching === true || isLoading === true; //added
    
    const [isClearing, setIsClearing] = useState(false);

    const clear = () => {
       // safety check to make sure we don't reload when already loading!
        if (isNextPageLoading || !isReady) {
            return;
        }
        
        const newCacheKey = new Date().valueOf();

        //console.log('in clear - filters', filter);
        setIsClearing(true);
        searchTrigger({
            cacheKey: newCacheKey,
            searchType: searchType,
            filter:{
                ...filter,
                adviserIds: filter.advisers?.map(x => x.value) ?? [],
                introducerIds: filter.introducers?.map(x => x.value) ?? [],
                masterAccountIds: filter.masterAccounts?.map(x => x.value) ?? [],
                providerIds: filter.providers?.map(x => x.value) ?? [],
                limit,
                page: 1,
                sort
            }
        }).finally(() => { 
            //console.log("Finally clear", filter);
            setCacheKey(_ => newCacheKey); 
            setIsClearing(false); 
        });
    };
    
    const isItemLoaded = (index) => index < results.length || results[index];
    
    const isRowLoaded = (index) => !hasMore || index < results.length;

    const loadMoreItems = () => {
        //console.log("In load more 1", filter);

         // safety check to make sure we don't reload when already loading!
         if (isNextPageLoading) {
            return;
        }
        //console.log("In load more", filter);
        searchTrigger({
            cacheKey,
            searchType: searchType,
            filter:{...filter,
            adviserIds: filter.advisers?.map(x => x.value) ?? [],
            introducerIds: filter.introducers?.map(x => x.value) ?? [],
            masterAccountIds: filter.masterAccounts?.map(x => x.value) ?? [],
            providerIds: filter.providers?.map(x => x.value) ?? [],
            limit,
            page: page + 1,
            sort}
        });
    };

    const retrySearchFees = (e) => {
        if (isUninitialized || !isReady || isNextPageLoading ) return; //added
        if (e && typeof (e) === "function") {
            e.preventDefault();
        }

        clear();
    };

    const updateSort = (property) => {
        const [oldProperty, direction] = sort.split("+");

        if (oldProperty === property) {
            return setSort(`${property}+${direction === "ASC" ? "DESC" : "ASC"}`)
        }

        setSort(`${property}+DESC`);
    };
   
    useEffect(clear, [filter, sort, isReady]);

    return <SearchFeesContext.Provider value={{
        results: results || [],
        totalCount: results.length > 0 && hasMore ? results.length + limit : results.length,
        page,
        isClearing,
        isLoading,
        isFetching,
        error,
        isError,
        sort,
        isRowLoaded,
        clear,
        isItemLoaded,
        loadMoreItems,
        retrySearchFees,
        updateSort,
        isNextPageLoading,
    }}>
        {children}
    </SearchFeesContext.Provider>
};
//};
export default SearchFeesProvider;